export default __webpack_public_path__ + "static/media/backgroundIcon.ce392cb5.svg";